module.exports = __webpack_public_path__ + "static/media/bolso (16).3119d147.jpg";